import React from "react";

const Footer = ({ enrollments }) => {
  return (
    <div className="">
      <div className="bg-gray-300 p-8">
        <h5>Note from Admin:</h5>
        {enrollments.deniedMessage}
      </div>
    </div>
  );
};

export default Footer;
